import _ from 'lodash';
import ApiUtil from './ApiUtil';

export default class InfoPuller {
  static getUserFromState = async (user) => {
    if (_.get(user, 'userId', null) === null) {
      user = await ApiUtil.getUserInfo();
    }
    return user;
  }
}
